import styled from "styled-components";

//widthnavbar = 300px

export const AppContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  //   height: 100%;
  width: 100%;
  //   flex-grow: 1;
`;

export const Navigation = styled.div`
  width: 300px;
  flex-shrink: 0;
  background: #fff;
  //   height: 100vh;
  //   border: 5px solid purple;
`;

// Duplicate
// export const Body = styled.div`
//   padding: 12px;
//   height: 100vh;
//   // width: 900px;
// `;

// Unused
// export const Title = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: 12px;
//   border: 5px solid yellow;
// `;

// Not used
// export const ExampleContainer = styled.div`
//   background: #fff;
//   border: 5px solid yellow;
//   height: calc(100vh - 40px);
// `;

export const ExampleNavigation = styled(Navigation)`
  //   height: 100%;
  margin-right: 4px;
  //   border: 2px solid green;
`;

// Main body
export const ExampleBody = styled.div`
  //   border: 5px solid blue;
  //   padding: 12px;
  width: 700px;
  //   heigth: 100%;
  //   margin-left: 0px;
  //   background-color: #dddddd;
  justify-content: center;
  text-align: center;
  margin-left: 5px;
`;
